import React from "react";
import { Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { DrawerFormValues } from "src/models/Drawer.model";
import {
  useDrawerInOutMutation,
  useGetAllDrawerDataQuery,
} from "src/services/DrawerService";
import { showToast } from "src/utils/showToaster";
import { useNavigate } from "react-router-dom";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import DrawerInOutFlowForm from "../Layouts/DrawerInOutForm";

const DrawerInFlowFormWrapper = () => {
  const { data } = useGetAllDrawerDataQuery("");
  const [submitDrawerData] = useDrawerInOutMutation();
  const navigate = useNavigate();

  // Extract physical note types only
  const physicalModes =
    data?.data?.filter((mode: any) => mode?.type === "PHYSICAL") || [];

  // Map API data into form values format
  const initialValues: DrawerFormValues = {
    type: "INFLOW",
    reason: "",
    notes: physicalModes.map((mode: any) => ({
      name: mode.name,
      value: mode.value,
      quantity: "",
      type: mode.type,
      availableQuantity: mode.quantity,
    })),
  };

const validationSchema = Yup.object().shape({
  reason: Yup.string().required("Reason is required"),
  notes: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Required"),
        value: Yup.number().required("Required"),
        quantity: Yup.string()
          .test(
            "is-valid-if-filled",
            "Must be a valid positive number",
            function (value) {
              // Only validate if the field has a value
              if (value === "" || value === undefined) return true;
              const num = Number(value);
              return !isNaN(num) && num >= 0;
            }
          )
      })
    )
    .test(
      "at-least-one",
      "At least one quantity must be entered",
      (notes:any) => {
        return notes.some((note:any) => 
          note.quantity && 
          note.quantity !== "" && 
          !isNaN(Number(note.quantity)) &&
          Number(note.quantity) >= 0
        );
      }
    )
});
  const handleSubmit = async (
    values: DrawerFormValues,
    { setSubmitting, resetForm }: FormikHelpers<DrawerFormValues>
  ) => {
    const payload = {
      type: values.type,
      reason: values.reason,
      notes: values.notes
        .filter((note) => Number(note.quantity) > 0)
        .map((note) => ({
          name: note.name,
          value: note.value,
          quantity: Number(note.quantity),
          type: note.type,
        })),
    };

    try {
      const res = await submitDrawerData(payload).unwrap();
      if (res?.status) {
        showToast("success", res?.message);
        navigate("/drawer");
        resetForm();
      } else {
        showToast("error", res?.message || "Submission failed");
      }
    } catch (err: any) {
      showToast("error", err?.data?.message || "API Error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {(formikProps) => (
        <Form>
          <SideNavLayout>
            {" "}
            <DrawerInOutFlowForm formikProps={formikProps} title="Cash in" />
          </SideNavLayout>
        </Form>
      )}
    </Formik>
  );
};

export default DrawerInFlowFormWrapper;
